import axios from 'axios';
import { Validator } from 'vee-validate';
import otherinformation from './otherinformation/index.vue';
import contracts from './contracts/index.vue';
import clientKYC from './clientKYC/index.vue';
import clientLog from './clientlog/index.vue';

export default {
	name: 'Template1',
	components: {
		'first': clientKYC,
		'second': otherinformation,
	 	'third': contracts,
		'four' : clientLog
	},
	props: ['selectedViewRow','clientShortName','selectclientSystemID','statelist','selectBusinessAccId'],
	data() {
		return {
			selectedEditRow : '',
			cargoclientShortName : '',
			currentTab: 'First',
			componentKey: 0,
			tabs: [{
					key: 'First',
					value: 'Client KYC'
				},
				{
					key: 'Second',
					value: 'Other Information'
				},
				{
					key: 'Third',
					value: 'Contracts'
				},
				{
					key: 'Four',
					value: 'Approval Logs'
				}
			],
		}
	},
	created: function() {

	},
	computed: {
		currentTabComponent: function() {
			this.componentKey += 1;
			if (this.selectedViewRow) {
				this.selectedEditRow = this.selectedViewRow;
				this.cargoclientShortName = this.clientShortName;
				this.selectclientSystemID = this.selectclientSystemID;
				this.selectBusinessAccId = this.selectBusinessAccId;
			}
			return this.currentTab.toLowerCase()
		},
	},
	mounted() {
	},
	methods: {
		setTab(tab){
			this.$nextTick(() => {
				let currentTabIndex = 0;
				this.tabs.forEach((el, index) => {
					if (el.key == tab) {
						currentTabIndex = index;
					}
				});
				this.componentKey = currentTabIndex;
				this.currentTab = this.tabs[this.componentKey].key;
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/client/clientlisting/clienteview/clienteview.component.js